import React from 'react';
import { FileText } from 'lucide-react';

export const ContentsPageHeader = () => {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-3 mb-2">
        <FileText className="w-8 h-8 text-accent" />
        <h1 className="text-3xl sm:text-4xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
          İçerikler
        </h1>
      </div>
      <p className="text-gray-600 text-base sm:text-lg">
        Tüm içerikleri görüntüleyin ve yönetin
      </p>
    </div>
  );
};
